export const CALCULATIONS_MUTATION_KEY = ['calculations'] as const;
